module.exports = __webpack_public_path__ + "img/w47b.b4fecddf.jpg";